import React, { Component } from "react";

import "./Footer.scss"
import yitLogoSrc from "../../assets/images/mobile/yit.png"

class Footer extends Component {
  constructor() {
    super();
    this.state = {
      yitLogo: {
        backgroundImage: "url(" + yitLogoSrc + ")"
      }
    }
  }
  render() {
    return (
      <footer>
        <div id="footer">
            <div className="padding">
                <a href="//www.yit.co.il/" title="YIT" target="_blank" rel="noopener noreferrer">
                <div className="credit">אפיון, עיצוב ופיתוח</div><div className="yitlogo" style={this.state.yitLogo}></div>
                </a>
            </div>
        </div>
        </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js